import { js_utils } from "./frfr-js-utils";


// const frfr_lib_changes_id = '/FRFR/frfr-rapidozi-contact-utils.js/changes_id2025-12-12r1/';


/* 
FrFr FRIENDLY FRAMEWORK
frfr-rapidozi-contact-utils
Version ID: 1a 2025-12-12r1
by 
// Please describe here if you customized this file
*/

/*
INSPIRACIJA

*/

//
export const rapidozi_contact_utils = {};


//
rapidozi_contact_utils.fix_contact_website_url = (url) => { // PURE
  // example: mywebsite.com fix to //mywebsite.com
  if (typeof url === 'string') {
    if (url.startsWith("http")) {
    } else {
      if (url.startsWith("/")) {
      } else {
        return '//' + url.trim(); // PURE
      }
    }
    return url.trim();
  }
  // return unchanged
  return url;// return unchanged
};


//
rapidozi_contact_utils.fix_contact_phone_number = (phone) => { // PURE
  // example: mywebsite.com fix to //mywebsite.com
  if (js_utils.is_number_or_string(phone)) {
    let _phone = '' + phone; // convert to string
    // The trim() method of String values removes whitespace from both ends of this string and returns a new string, without modifying the original string.
    _phone = _phone.trim(); //
    // The replaceAll() method of String values returns a new string with all matches of a pattern replaced by a replacement.
    _phone = _phone.replaceAll(" ", ""); // remove all space characters
    return _phone;
  }
  // return unchanged
  return phone; // return unchanged
};

